import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query ActivitiesStates {
  activitiesStates {
    state
  }
}`;

function getActivitiesStates() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((data) => data.data.activitiesStates);
}

export default getActivitiesStates;
